import RailsResource from './rails-resource';

class TemplateContractService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'contracts',
      ajaxLoader: true
    });
  }
}

export default new TemplateContractService();
